import React from "react";
import { FiArrowRight, FiCalendar, FiClock } from "react-icons/fi";
import { motion } from "framer-motion";
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from "../../../components/card";

function AnnouncementCard({
  announcement,
  onCardClick,
  onPhotoClick,
  formatDate,
}) {
  return (
    <motion.div whileHover={{ scale: 1.02 }} transition={{ duration: 0.2 }}>
      <Card
        className="h-full border border-gray-100 rounded-xl overflow-hidden bg-white cursor-pointer shadow-sm hover:shadow-md transition-all duration-300"
        onClick={() => onCardClick(announcement)}
      >
        <div className="flex flex-row h-full">
          {announcement.poster && (
            <div className="relative w-1/3 flex-shrink-0 min-h-[120px] p-3">
              <div
                className="relative h-full w-full"
                onClick={(e) => {
                  e.stopPropagation();
                  onPhotoClick(e, announcement.poster);
                }}
              >
                <img
                  src={announcement.poster}
                  alt={announcement.title}
                  className="w-full h-full object-cover rounded-lg border-2 border-[#363062]/10 shadow-sm cursor-pointer"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg"></div>
              </div>

              {announcement.isNew && (
                <div className="absolute top-5 left-5 bg-[#8FCD00] text-white px-2.5 py-0.5 rounded-full text-[10px] font-medium z-10 flex items-center shadow-sm">
                  <span className="mr-1 h-1.5 w-1.5 bg-white rounded-full inline-block"></span>
                  NEW
                </div>
              )}
            </div>
          )}

          <div
            className={`flex flex-col ${
              announcement.imageUrl ? "w-2/3 pl-0" : "w-full"
            } p-3`}
          >
            <CardHeader className="p-0 pb-2">
              <div className="flex items-start justify-between">
                <CardTitle className="text-base font-semibold text-[#363062] line-clamp-2">
                  {announcement.title}
                </CardTitle>
              </div>
              <CardDescription className="text-xs text-gray-500 mt-1.5 flex items-center">
                <FiCalendar className="mr-1 h-3 w-3" />
                {formatDate(announcement.createdAt)}
              </CardDescription>
            </CardHeader>

            <CardContent className="p-0 text-sm flex-grow">
              <p className="text-gray-600 line-clamp-2 text-xs">
                {announcement.description}
              </p>
            </CardContent>

            <CardFooter className="flex justify-between items-center p-0 pt-3 mt-auto">
              {!announcement.imageUrl && announcement.isNew && (
                <div className="bg-[#8FCD00]/10 text-[#8FCD00] px-2 py-0.5 rounded-full text-xs font-medium flex items-center">
                  <span className="mr-1 h-1.5 w-1.5 bg-[#8FCD00] rounded-full inline-block"></span>
                  NEW
                </div>
              )}

              {!announcement.isNew && !announcement.link && (
                <div className="text-xs text-gray-400 flex items-center">
                  <FiClock className="mr-1 h-3 w-3" />
                  <span>Posted {formatDate(announcement.createdAt)}</span>
                </div>
              )}

              {announcement.link && (
                <a
                  href={announcement.link}
                  onClick={(e) => e.stopPropagation()}
                  className="ml-auto flex items-center text-xs font-medium text-[#363062] hover:text-[#8FCD00] transition-colors group"
                >
                  Learn More
                  <FiArrowRight className="ml-1 group-hover:translate-x-1 transition-transform" />
                </a>
              )}
            </CardFooter>
          </div>
        </div>
      </Card>
    </motion.div>
  );
}

export default AnnouncementCard;
